<template>
    <div class="">
        <gcmcn-filters
            ref="gcmcn-filters"
            :filter-values="[
                selectedSortType,
                searchFilter,
                selectedEntitiesForFilter,
                selectedUniversesForFilter
            ]"
            @reset-filters="resetFilters"
        >
            <dropdown
                name="Sort"
                :multiple="false"
                :list="$store.getters.sortTypeList"
                itemName="name"
                itemValue="value"
                :itemsSelected="selectedSortType.length > 0 ? [selectedSortType] : []"
                @on-select-item="selectedSortType = $event"
            ></dropdown>
            <dropdown
                name="Entities"
                :multiple="true"
                :list="entities"
                itemName="display_name"
                itemValue="uid"
                :itemsSelected="selectedEntitiesForFilter"
                @on-select-item="onSelectEntity"
            ></dropdown>
            <dropdown
                name="Universes"
                :multiple="true"
                :list="filteredUniverses"
                itemName="display_name"
                itemValue="uid"
                :itemsSelected="selectedUniversesForFilter"
                @on-select-item="onSelectUniverses"
            ></dropdown>
            <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
        </gcmcn-filters>
        <div v-if="filteredFeedResources.length > 0" class="feed-ns-loader">
            <feed-resource-card
                v-for="resource in filteredFeedResources"
                :key="resource.uid"
                :feed-resource="resource"
                :universes="universes"
                :selected-feed-resource="selectedFeedResource"
                @select-feed-resource="selectFeedResource"
            ></feed-resource-card>
        </div>
        <div v-else class="list-empty">no feed resources</div>
    </div>
</template>

<script>
import {
    Dropdown,
    DatePickerRange,
    SearchFilter,
    GcmcnFilters,
} from 'gcmcn-common';
import FeedResourceCard from './feed-resource-card.vue';
import {mapGetters} from 'vuex';
export default {

    name: 'FeedResourceList',
    components: {
        Dropdown,
        DatePickerRange,
        SearchFilter,
        FeedResourceCard,
        GcmcnFilters,
    },
    props:{
        selectedFeedResource: {
            required: true,
        },
        feedResources: {
            type: Array,
            required: true,
        },
        universes: {
            type: Array,
            required: true,
        },
        events: {
            type: Array,
            required: true,
        },
    },
    data () {
        return {
            searchFilter: '',
            selectedSortType: 'asc',
            usedHeight: 0,
            resized: false,
        };
    },
    computed: {
        ...mapGetters([
            'windowWidth',
            'orderingFeedResources',
            'entities',
            'selectedEntitiesForFilter',
            'selectedUniversesForFilter',
        ]),
        filteredUniverses(){
            if(this.selectedEntitiesForFilter.length > 0){
                let universes = [...this.universes];
                let filteredUniverses = universes.filter(universe=>{
                    return  this.selectedEntitiesForFilter.includes(universe.scopes.entity_uid);

                });
                return filteredUniverses;
            }
            return this.universes;
        },
        filteredFeedResources (){
            let feedResources = this.feedResources.slice();

            if(this.selectedEntitiesForFilter.length > 0){
                feedResources = feedResources.filter((feedResource) => this.selectedEntitiesForFilter.includes(feedResource.scopes.entity_uid));
            }
            if(this.selectedUniversesForFilter.length > 0){
                feedResources = feedResources.filter((ev) => this.selectedUniversesForFilter.includes(ev.universe_uid));
            }
            if(this.searchFilter.length > 0){
                let searchFilter = this.searchFilter.toLowerCase();
                feedResources = feedResources
                .filter(
                    (feedResource) => feedResource.display_name.toLowerCase().includes(searchFilter)
                        || this.events.find((ev) => ev.uid === feedResource.event_uid).name.toLowerCase().includes(searchFilter)
                        || this.universes.find((universe) => universe.uid === feedResource.universe_uid).name.toLowerCase().includes(searchFilter)
                );
            }

            feedResources = this.orderingFeedResources(feedResources);
            if(this.selectedSortType === 'dsc'){
                feedResources.reverse();
            }
            return feedResources;
        },
    },
    watch: {
        windowWidth (){
            this.computeFilterHeight();
        },
        selectedEntitiesForFilter(){
            let filteredUniversesUid = this.filteredUniverses
            .map(universe=>{
                return  universe.uid;

            });
            let selectedUniverseUids = this.selectedUniversesForFilter.filter(uid =>{
                return filteredUniversesUid.includes(uid);
            });
            this.$store.commit('SET_UNIVERSES_FOR_FILTER', selectedUniverseUids);
        }
    },
    methods: {
        computeFilterHeight() {
            if(this.$refs['gcmcn-filters']){
                const clientRect = this.$refs['gcmcn-filters'].$el.getBoundingClientRect();
                this.usedHeight = clientRect.top + clientRect.height + 10 + 32; // +10 par ce que l'element contient un margin, et les margin ne sont pas comptés dans la height d'un element
                // 32 -> on enleve la height du wrapper d'alerte de fundation
            }
        },
        resetFilters (){
            this.$store.commit('CLEAR_ALL_FILTERS');
            this.$refs.search.clear();
        },
        selectFeedResource (feedResource){
            this.$emit('select-feed-resource', feedResource);
        },
        onSelectEntity (entities){
            this.$store.commit('SET_ENTITIES_FOR_FILTER', entities);
        },
        onSelectUniverses (universes){
            this.$store.commit('SET_UNIVERSES_FOR_FILTER', universes);
        },
    },
};
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/page/FeedResources/feed-resource-list.vue